import { formatInTimeZone } from 'date-fns-tz';

import { REPUBS } from '@cx-modules/constants';
import { type Repub } from '@cx-modules/types';

export const formatFullTimeDateInTimeZone = (dateString: string, repub: Repub) => {
  if (!dateString) {
    return '';
  }

  return formatInTimeZone(
    dateString,
    REPUBS[repub].dateProperties.timezone,
    REPUBS[repub].dateProperties.format.timeDateFull,
    {
      locale: REPUBS[repub].dateProperties.locale,
    },
  );
};
